import { useState } from "react";
import styled, { css } from "styled-components";
import { getLocale } from "react-i18nify";

import { Grid, IconButton, Box } from "@mui/material";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
// import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import VideoCameraBackOutlinedIcon from "@mui/icons-material/VideoCameraBackOutlined";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

import font from "src/styles/font";
import { checkNotEmpty } from "src/common";
import { UseUpload } from "src/context/UploadProductContext";
import { useDialog } from "src/context/DialogContext";

import Button from "src/components/core/Button";
import ProductCard from "src/components/product/ProductCard";
import UploadImage from "src/components/upload/dropzone/UploadImage";
import UploadVideo from "src/components/upload/dropzone/UploadVideo";
import GenerateImageDialog from "src/modules/product/upload/modal/GenerateImageDialog";

const Container = styled.div`
  width: 100%;
  max-width: 1240px;
  height: max-content;
  margin: 0 auto;
  padding: 40px 64px;
`;

const SpanTitle = styled.div`
  font-size: ${font.size.md};
  color: var(--secondary-color);
  font-weight: 600;

  span {
    font-size: ${font.size.md};
    font-weight: 600;
    color: var(--primary-color);
  }
`;

const SpanSubTitle = styled.div`
  font-size: ${font.size.md};
  color: var(--darkgrey-color);
  font-weight: 400;
  margin-top: 8px;

  span {
    font-size: ${font.size.md};
    font-weight: 400;
    color: var(--primary-color);
  }
`;

const SpanLabel = styled(Box)`
  font-size: ${font.size.md};
  color: var(--secondary-color);
  font-weight: 400;
  text-align: center;

  span {
    font-size: ${font.size.md};
    font-weight: 400;
    color: var(--primary-color);
  }
`;

const ShowImageBox = styled.div`
  margin: 0 auto;
  width: max-content;
  display: flex;
`;

const WrapperShowImage = styled.div`
  /* margin: 0 auto; */
`;

const WrapperProductCard = styled.div`
  width: 200px !important;
  padding-bottom: 1px;
  position: relative;
  margin-bottom: 40px;
  margin: 0 40px 0 auto;
`;

const WrapperUploadImage = styled.div`
  width: 371px;
  height: 330px;
  padding-left: 40px;
  border-left: 1px dashed var(--primary-color);
  position: relative;
`;

const UploadHover = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #6c6c7090;
  border-radius: inherit;
  display: none;
  top: 0;
  align-items: center;
  justify-content: center;
  visibility: hidden;
`;

const WrapperVideo = styled.div`
  width: 330px;
  height: 330px;
  background-color: var(--lightgrey-color);
  border-radius: 24px;
  /* padding: 10px; */
  cursor: pointer;
  position: relative;

  opacity: 0.95;
  object-fit: contain;
  object-position: center;

  .plus-video {
    visibility: visible;
  }

  div:nth-child(2) {
    visibility: visible;
    opacity: 1;
  }
  &:hover {
    .plus-detail {
      visibility: visible;
    }
    .hover-upload {
      display: flex;
      visibility: visible;
    }
  }

  &:first-child {
    display: block;
  }
`;

const VideoMain = styled.video`
  width: 100%;
  height: 100%;
  border-radius: inherit;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;

  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;

const WrapperImage = styled.div`
  width: 330px;
  height: 330px;
  background-color: var(--lightgrey-color);
  border-radius: 24px;
  /* padding: 10px; */
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    .hover-upload {
      display: flex;
      visibility: visible;
    }
  }
`;

const ImgShow = styled.img`
  width: 100%;
  height: 100%;
  border-radius: inherit;
  object-fit: cover;
`;

const EmptyText = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: var(--white-color);
  text-align: center;
  margin-top: 8px;
`;

const WrapperGenerateBtn = styled.div`
  width: calc(100% - 40px);
  position: absolute;
  bottom: 0;
  padding: 16px;
`;

const StyledGenerateBtn = styled(Button)`
  width: 100%;

  &.MuiButton-dashed {
    border-radius: 24px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  }
`;

const SelectImgSection = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  gap: 16px 8px;
`;

const MainCard = styled.div`
  border-right: 1px dashed var(--primary-color);
  padding-right: 8px;
`;

const Card = styled.div`
  padding: 16px;
  border-radius: 16px;
  cursor: pointer;
  user-select: none;

  > div > button.remove-image {
    display: none;
    position: absolute;
    top: 5px;
    right: 5px;
  }

  :hover:not(.new-tool-presentation) {
    outline: 1px dashed var(--primary-color);

    > div {
      > img {
        filter: brightness(0.7);
      }

      > button.remove-image {
        display: inline-flex;
      }
    }

    /* ~ div.card-empty > svg {
      color: var(--grey-color);
    } */
  }
  &:active {
    outline: 1px solid var(--primary-color);
  }

  &.new-tool-presentation {
    --border-angle: 0turn; // For animation.
    --main-bg: conic-gradient(
      from var(--border-angle),
      var(--white-color) 0deg,
      var(--white-color) 360deg
    );
    --gradient-border: conic-gradient(
      from var(--border-angle),
      transparent 25%,
      #08f,
      #f03 99%,
      transparent
    );

    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    border: solid 2px transparent;
    border-radius: 16px;
    background: 
    // padding-box clip this background in to the overall element except the border.
      var(--main-bg) padding-box,
      // border-box extends this background to the border space
      var(--gradient-border) border-box,
      // Duplicate main background to fill in behind the gradient border. You can remove this if you want the border to extend "outside" the box background.
      var(--main-bg) border-box;
    background-position: center center;

    animation: bg-spin 5s linear infinite;
    animation-delay: 2s;
    @keyframes bg-spin {
      to {
        --border-angle: 1turn;
      }
    }

    @property --border-angle {
      syntax: "<angle>";
      inherits: true;
      initial-value: 0turn;
    }

    &:hover {
      animation-play-state: paused;
    }
  }

  ${({ selected }) =>
    selected &&
    css`
      outline: 1px solid var(--primary-color);

      :hover {
        outline: 1px solid var(--primary-color);
      }
    `}
`;

const WrapImgCard = styled.div`
  width: 100px;
  height: 100px;
  position: relative;
  border-radius: 16px;
`;

const ImageCard = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
`;

const WrapVideoCard = styled.div`
  width: 100px;
  height: 100px;
  position: relative;
  border-radius: 16px;

  .play-video {
    visibility: visible;
  }
`;

const VideoCard = styled.video`
  width: 100%;
  height: 100%;
  opacity: 0.8;
  object-fit: cover;
  object-position: center;
  vertical-align: initial;
  border-radius: inherit;
`;

const VideoPlayBg = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #25252599;
  border-radius: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CardEmpty = styled.div`
  width: 100px;
  height: 100px;
  background-color: var(--lightgrey-color);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    > svg {
      color: var(--grey-color);
    }
  }
`;

const CardText = styled.div`
  max-width: 100px;
  margin-top: 16px;
  text-align: center;
  font-size: ${font.size.sm};
  font-weight: 400;
  color: var(--darkgrey-color);
  white-space: pre-line;
  word-break: break-word;

  span {
    font-size: ${font.size.sm};
    font-weight: 400;
    color: var(--primary-color);
  }
`;

const Step2 = () => {
  const { openDialog, closeDialog, closeAllDialogs } = useDialog();
  const { dataUpload, dataUploadChoice, onChangeUpload } = UseUpload();

  const [selectedImg, setSelectedImg] = useState({
    name: "product_display_image",
    label: "Product card image",
  });
  const imageList = [
    {
      name: "product_display_image",
      label: "Product card image",
    },
    {
      name: "product_full_image",
      label: "Product full image",
    },
    {
      name: "product_closeup_image",
      label: "Close up image",
    },
    {
      name: "product_other1_image",
      label: "Install\nimage",
    },
    {
      name: "product_other2_image",
      label: "Other\nimage",
    },
    {
      name: "product_other3_image",
      label: "Other\nimage",
    },
    {
      name: "product_video",
      label: "Product\nVideo",
    },
  ];

  return (
    <>
      <Container>
        {/* map choices */}
        {dataUploadChoice?.map((_, choiceIndex) => (
          <Grid
            container
            rowSpacing={3}
            sx={{
              m: 0,
              mb: 5,
              p: 3,
              pb: 5,
              width: "100%",
              borderRadius: 6,
              background: "var(--white-color)",
              boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.10)",
              "&:last-child": {
                mb: 0,
              },
              "&>.MuiGrid-item:first-child": {
                pt: 0,
              },
            }}
          >
            <Grid item xs={12}>
              <SpanTitle>ภาพตัวเลือกสินค้าที่ {`${choiceIndex + 1}`}</SpanTitle>

              {dataUpload.is_choice && (
                <SpanSubTitle>
                  {dataUploadChoice[choiceIndex]?.name !== ""
                    ? dataUploadChoice[choiceIndex]?.name
                    : `choice name`}
                </SpanSubTitle>
              )}
            </Grid>

            <Grid item xs={12}>
              <ShowImageBox>
                {/* ProductCard */}
                <WrapperShowImage>
                  <SpanLabel
                    sx={{
                      maxWidth: 200,
                      margin: "0 40px 16px auto",
                    }}
                  >
                    ตัวอย่างการ์ดสินค้า<span>*</span>
                  </SpanLabel>

                  <WrapperProductCard>
                    <ProductCard
                      emptyImage={
                        !checkNotEmpty(
                          dataUploadChoice[choiceIndex]?.group_image
                            ?.product_display_image,
                        )
                      }
                      // sellerLogo={product?.product?.user?.seller?.profile_image}
                      sellerName={
                        dataUpload?.user_id?.seller?.company_name ||
                        `Company name`
                      }
                      src={
                        typeof dataUploadChoice[choiceIndex]?.group_image
                          ?.product_display_image === "string"
                          ? dataUploadChoice[
                              choiceIndex
                            ]?.group_image?.product_display_image.replace(
                              ".com",
                              ".com/200x200",
                            )
                          : dataUploadChoice[choiceIndex]?.group_image
                              ?.product_display_image?.fileData
                      }
                      itemcode={dataUpload?.item_code || `Item code`}
                      itemname={dataUpload?.item_name || `Item name`}
                      price={dataUploadChoice[choiceIndex]?.group_price}
                      productType={
                        dataUpload?.product_types
                          ?.map((data) =>
                            getLocale() === "th" ? data.type_th : data.type_en,
                          )
                          .join(",") || `สีทาบ้าน,สีอะครีลิค`
                      }
                      size={dataUploadChoice[choiceIndex]?.size || `15 ลิตร`}
                      isPreOrder={dataUploadChoice[choiceIndex]?.pre_order_date}
                      isInstock={dataUploadChoice[choiceIndex]?.is_instock}
                      isInstall={dataUpload?.is_installer}
                    />
                  </WrapperProductCard>
                </WrapperShowImage>

                {/* Upload Image */}
                <WrapperShowImage>
                  <SpanLabel
                    sx={{
                      maxWidth: 330,
                      margin: "0 auto 16px 40px",
                    }}
                  >
                    เพิ่มภาพรายละเอียดสินค้า<span>*</span>
                  </SpanLabel>

                  {selectedImg.name === "product_video" ? (
                    <WrapperUploadImage>
                      <UploadVideo
                        callBackFile={(fileCallBlack) => {
                          fileCallBlack !== "" &&
                            onChangeUpload(
                              null,
                              `choices.${choiceIndex}.group_image.product_video`,
                              fileCallBlack,
                            );
                        }}
                        closeAlert={false}
                      >
                        {checkNotEmpty(
                          typeof dataUploadChoice[choiceIndex]?.group_image
                            ?.product_video === "string"
                            ? dataUploadChoice[choiceIndex]?.group_image
                                ?.product_video
                            : dataUploadChoice[choiceIndex]?.group_image
                                ?.product_video?.fileData,
                        ) ? (
                          <WrapperVideo>
                            <VideoMain
                              src={
                                typeof dataUploadChoice[choiceIndex]
                                  ?.group_image?.product_video === "string"
                                  ? dataUploadChoice[choiceIndex]?.group_image
                                      ?.product_video
                                  : dataUploadChoice[choiceIndex]?.group_image
                                      ?.product_video?.fileData
                              }
                              controls
                              autoPlay="autoplay"
                              preLoad="auto"
                              muted
                              type="video/mp4"
                            >
                              <source
                                src={
                                  typeof dataUploadChoice[choiceIndex]
                                    ?.group_image?.product_video === "string"
                                    ? dataUploadChoice[choiceIndex]?.group_image
                                        ?.product_video
                                    : dataUploadChoice[choiceIndex]?.group_image
                                        ?.product_video?.fileData
                                }
                                type="video/mp4"
                              />
                            </VideoMain>

                            <UploadHover className="hover-upload">
                              <Button
                                variant="contained"
                                size="large"
                                sx={{ width: "max-content", borderRadius: 4 }}
                              >
                                Change
                              </Button>
                            </UploadHover>
                          </WrapperVideo>
                        ) : (
                          <WrapperImage>
                            <VideoCameraBackOutlinedIcon
                              sx={{
                                fontSize: 48,
                                color: "var(--white-color)",
                              }}
                            />
                            <EmptyText>{selectedImg.label}</EmptyText>
                          </WrapperImage>
                        )}
                      </UploadVideo>
                    </WrapperUploadImage>
                  ) : (
                    <WrapperUploadImage>
                      <UploadImage
                        callBackFile={(fileCallBlack) => {
                          fileCallBlack !== "" &&
                            onChangeUpload(
                              null,
                              `choices.${choiceIndex}.group_image.${selectedImg.name}`,
                              fileCallBlack,
                            );
                        }}
                        closeAlert={false}
                      >
                        {checkNotEmpty(
                          typeof dataUploadChoice[choiceIndex]?.group_image[
                            selectedImg.name
                          ] === "string"
                            ? dataUploadChoice[choiceIndex]?.group_image[
                                selectedImg.name
                              ]
                            : dataUploadChoice[choiceIndex]?.group_image[
                                selectedImg.name
                              ]?.fileData,
                        ) ? (
                          <WrapperImage>
                            <ImgShow
                              src={
                                typeof dataUploadChoice[choiceIndex]
                                  ?.group_image[selectedImg.name] === "string"
                                  ? dataUploadChoice[choiceIndex]?.group_image[
                                      selectedImg.name
                                    ].replace(".com", ".com/200x200")
                                  : dataUploadChoice[choiceIndex]?.group_image[
                                      selectedImg.name
                                    ]?.fileData
                              }
                              alt={`selected-image`}
                            />

                            <UploadHover className="hover-upload">
                              <Button
                                variant="contained"
                                size="large"
                                sx={{ width: "max-content", borderRadius: 4 }}
                              >
                                Change
                              </Button>
                            </UploadHover>
                          </WrapperImage>
                        ) : (
                          <WrapperImage>
                            <AddPhotoAlternateOutlinedIcon
                              sx={{
                                fontSize: 48,
                                color: "var(--white-color)",
                              }}
                            />
                            <EmptyText>{selectedImg.label}</EmptyText>
                          </WrapperImage>
                        )}
                      </UploadImage>

                      {selectedImg.name === "product_other1_image" && (
                        <WrapperGenerateBtn>
                          <StyledGenerateBtn
                            variant="dashed"
                            onClick={() =>
                              openDialog({
                                type: "custom",
                                customDialog: (
                                  <GenerateImageDialog
                                    isOpen={true}
                                    onClose={() => closeDialog()}
                                    onSuccess={(fileCallBlack) => {
                                      onChangeUpload(
                                        null,
                                        `choices.${choiceIndex}.group_image.${selectedImg.name}`,
                                        fileCallBlack,
                                      );
                                      closeAllDialogs();
                                    }}
                                    itemCode={dataUpload?.item_code || null}
                                  />
                                ),
                              })
                            }
                          >
                            คลิ๊กเพื่อใช้ AI ใส่ภาพวัสดุในห้องตัวอย่าง
                          </StyledGenerateBtn>
                        </WrapperGenerateBtn>
                      )}
                    </WrapperUploadImage>
                  )}
                </WrapperShowImage>
              </ShowImageBox>
            </Grid>

            {/* Select image section */}
            <Grid item xs={12}>
              <SelectImgSection>
                {imageList.map((img, index) =>
                  img.name === "product_display_image" ? (
                    <MainCard key={`product_display_image-${index}`}>
                      <Card
                        selected={selectedImg.name === "product_display_image"}
                        onClick={() => setSelectedImg(img)}
                      >
                        {checkNotEmpty(
                          dataUploadChoice[choiceIndex]?.group_image
                            ?.product_display_image,
                        ) ? (
                          <WrapImgCard>
                            <ImageCard
                              src={
                                typeof dataUploadChoice[choiceIndex]
                                  ?.group_image?.product_display_image ===
                                "string"
                                  ? dataUploadChoice[
                                      choiceIndex
                                    ]?.group_image?.product_display_image.replace(
                                      ".com",
                                      ".com/200x200",
                                    )
                                  : dataUploadChoice[choiceIndex]?.group_image
                                      ?.product_display_image?.fileData
                              }
                            />

                            <IconButton
                              className="remove-image"
                              sx={{
                                p: "2px",
                                backgroundColor: "var(--darkgrey-color)",
                                "&:hover": {
                                  backgroundColor: "#6C6C70cc",
                                },
                              }}
                              onClick={() =>
                                onChangeUpload(
                                  null,
                                  `choices.${choiceIndex}.group_image.product_display_image`,
                                  "",
                                )
                              }
                            >
                              <ClearRoundedIcon
                                sx={{
                                  fontSize: "16px",
                                  color: "var(--white-color)",
                                }}
                              />
                            </IconButton>
                          </WrapImgCard>
                        ) : (
                          <UploadImage
                            callBackFile={(fileCallBlack) => {
                              fileCallBlack !== "" &&
                                onChangeUpload(
                                  null,
                                  `choices.${choiceIndex}.group_image.product_display_image`,
                                  fileCallBlack,
                                );
                            }}
                            closeAlert={false}
                          >
                            <CardEmpty className="card-empty">
                              <AddPhotoAlternateOutlinedIcon
                                sx={{
                                  fontSize: 48,
                                  color: "var(--white-color)",
                                }}
                              />
                            </CardEmpty>
                          </UploadImage>
                        )}

                        <CardText>
                          {img.label}
                          <span>*</span>
                        </CardText>
                      </Card>
                    </MainCard>
                  ) : img.name === "product_video" ? (
                    <Card
                      key={`${img.name}-${index}`}
                      selected={selectedImg.name === img.name}
                      onClick={() => setSelectedImg(img)}
                    >
                      {checkNotEmpty(
                        dataUploadChoice[choiceIndex]?.group_image
                          ?.product_video,
                      ) ? (
                        <WrapVideoCard>
                          <VideoCard
                            src={
                              typeof dataUploadChoice[choiceIndex]?.group_image
                                ?.product_video === "string"
                                ? dataUploadChoice[choiceIndex]?.group_image
                                    ?.product_video
                                : dataUploadChoice[choiceIndex]?.group_image
                                    ?.product_video.fileData
                            }
                          />

                          <VideoPlayBg>
                            <PlayArrowIcon
                              sx={{
                                fontSize: 32,
                                color: "var(--primary-color)",
                                borderRadius: "50%",
                                outline: "#fff solid 2px",
                              }}
                            />
                          </VideoPlayBg>

                          <IconButton
                            className="remove-image"
                            sx={{
                              p: "2px",
                              backgroundColor: "var(--darkgrey-color)",
                              "&:hover": {
                                backgroundColor: "#6C6C70cc",
                              },
                            }}
                            onClick={() =>
                              onChangeUpload(
                                null,
                                `choices.${choiceIndex}.group_image.${img.name}`,
                                "",
                              )
                            }
                          >
                            <ClearRoundedIcon
                              sx={{
                                fontSize: "16px",
                                color: "var(--white-color)",
                              }}
                            />
                          </IconButton>
                        </WrapVideoCard>
                      ) : (
                        <UploadVideo
                          callBackFile={(fileCallBlack) => {
                            fileCallBlack !== "" &&
                              onChangeUpload(
                                null,
                                `choices.${choiceIndex}.group_image.product_video`,
                                fileCallBlack,
                              );
                          }}
                          closeAlert={false}
                        >
                          <CardEmpty>
                            <VideoCameraBackOutlinedIcon
                              sx={{
                                fontSize: 48,
                                color: "var(--white-color)",
                              }}
                            />
                          </CardEmpty>
                        </UploadVideo>
                      )}

                      <CardText>
                        {img.label}
                        {img.label === `Product full image` && <span>*</span>}
                      </CardText>
                    </Card>
                  ) : (
                    <Card
                      key={`${img.name}-${index}`}
                      className={
                        img.name === "product_other1_image"
                          ? "new-tool-presentation"
                          : ""
                      }
                      selected={selectedImg.name === img.name}
                      onClick={() => setSelectedImg(img)}
                    >
                      {checkNotEmpty(
                        dataUploadChoice[choiceIndex]?.group_image[img.name],
                      ) ? (
                        <WrapImgCard>
                          <ImageCard
                            src={
                              typeof dataUploadChoice[choiceIndex]?.group_image[
                                img.name
                              ] === "string"
                                ? dataUploadChoice[choiceIndex]?.group_image[
                                    img.name
                                  ].replace(".com", ".com/200x200")
                                : dataUploadChoice[choiceIndex]?.group_image[
                                    img.name
                                  ].fileData
                            }
                          />

                          <IconButton
                            className="remove-image"
                            sx={{
                              p: "2px",
                              backgroundColor: "var(--darkgrey-color)",
                              "&:hover": {
                                backgroundColor: "#6C6C70cc",
                              },
                            }}
                            onClick={() =>
                              onChangeUpload(
                                null,
                                `choices.${choiceIndex}.group_image.${img.name}`,
                                "",
                              )
                            }
                          >
                            <ClearRoundedIcon
                              sx={{
                                fontSize: "16px",
                                color: "var(--white-color)",
                              }}
                            />
                          </IconButton>
                        </WrapImgCard>
                      ) : (
                        <UploadImage
                          callBackFile={(fileCallBlack) => {
                            fileCallBlack !== "" &&
                              onChangeUpload(
                                null,
                                `choices.${choiceIndex}.group_image.${img.name}`,
                                fileCallBlack,
                              );
                          }}
                          closeAlert={false}
                        >
                          <CardEmpty>
                            <AddPhotoAlternateOutlinedIcon
                              sx={{
                                fontSize: 48,
                                color: "var(--white-color)",
                              }}
                            />
                          </CardEmpty>
                        </UploadImage>
                      )}

                      <CardText>
                        {img.label}
                        {img.label === `Product full image` && <span>*</span>}
                      </CardText>
                    </Card>
                  ),
                )}
              </SelectImgSection>
            </Grid>
          </Grid>
        ))}
      </Container>
    </>
  );
};

export default Step2;
